import { useEffect } from "react";

const useSmoothAnchor = (targetId: string) => {
  useEffect(() => {
    const anchors = document.querySelectorAll(`a[href^="#${targetId}"]`);
    const eventRemovers: (() => void)[] = [];
    anchors.forEach((anchor) => {
      const scrollToTarget = (event: Event) => {
        event.preventDefault();
        const targetId = anchor.getAttribute("href");
        if (targetId) {
          document.querySelector(targetId)?.scrollIntoView({ behavior: "smooth" });
        }
      };
      anchor.addEventListener("click", scrollToTarget);
      eventRemovers.push(() => anchor.removeEventListener("click", scrollToTarget));
    });
    return () => {
      eventRemovers.forEach((remover) => {
        remover();
      });
    };
  }, []);
};
export default useSmoothAnchor;
